import type { Dispatch, FC, PropsWithChildren, SetStateAction } from 'react';
import React from 'react';
import type { User, OpportunityCandidate } from '@axiom/validation';
import {
  CondensedLarge,
  ContextMenuItem,
  ClipboardUtil,
  ToastUtil,
} from '@axiom/ui';

import type { TalentInterviewAvailabilityModalProps } from '../TalentInterviewAvailabilityModal/TalentInterviewAvailabilityModal';
import { EnvUtil } from '../../utils/env-util';

interface CandidateCalendarMenuContentProps extends PropsWithChildren {
  user: User;
  onEditAvailability: Dispatch<
    SetStateAction<TalentInterviewAvailabilityModalProps['defaultMode'] | null>
  >;
  opportunityCandidate?: OpportunityCandidate;
}

export const CandidateCalendarMenuContent: FC<
  CandidateCalendarMenuContentProps
> = ({ onEditAvailability, children, opportunityCandidate }) => {
  const allowedStatuses = ['Submitted', 'Interviewing', 'Selected'];
  return (
    <>
      {children}
      <ContextMenuItem
        onClick={() => {
          onEditAvailability('availability');
        }}
        name="EDIT"
      >
        Edit Interview Availability
      </ContextMenuItem>
      {allowedStatuses.includes(opportunityCandidate?.candidateStatus) ? (
        <ContextMenuItem
          onClick={() => {
            onEditAvailability('interview');
          }}
          name="SCHEDULE"
        >
          Schedule Interview
        </ContextMenuItem>
      ) : null}
      <ContextMenuItem
        name="COPY_URL"
        onClick={async () => {
          await ClipboardUtil.copy({
            text: `${EnvUtil.portalUrl}/talent/profile/interview-availability`,
          });
          const toastName = `COPY_TALENT_AVAILABILITY`;

          ToastUtil.add({
            name: toastName,
            type: 'info',
            children: (
              <CondensedLarge>Talent availability link copied!</CondensedLarge>
            ),
          });
        }}
      >
        Copy Interview Availability Link
      </ContextMenuItem>
    </>
  );
};
